import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-122feb71"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "process" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"process__title\" data-v-122feb71><h2 class=\"process__title--h2\" data-v-122feb71>Exalab te acompaña</h2><p class=\"process__title--p\" data-v-122feb71>en todo tu proceso de <strong class=\"process__title--strong\" data-v-122feb71>exámenes preocupacionales</strong></p></div><div class=\"process__diagram\" data-v-122feb71><div class=\"process__diagram--content\" data-v-122feb71><a name=\"process-item-1\" class=\"process__diagram--item\" data-v-122feb71><div class=\"process__diagram--circle\" data-v-122feb71><div class=\"process__diagram--number\" data-v-122feb71>2</div><div class=\"process__diagram--icon\" style=\"color:hsla(55,67%,52%,1);\" data-v-122feb71><i class=\"process__diagram--i ri-calendar-schedule-line\" data-v-122feb71></i></div></div><div class=\"process__diagram--title\" data-v-122feb71><h3 class=\"process__diagram--h3\" data-v-122feb71>Solicitud<br class=\"br-escritorio\" data-v-122feb71> de atención</h3></div></a><a name=\"process-item-2\" class=\"process__diagram--item\" data-v-122feb71><div class=\"process__diagram--circle\" data-v-122feb71><div class=\"process__diagram--number\" data-v-122feb71>2</div><div class=\"process__diagram--icon\" data-v-122feb71><i class=\"process__diagram--i ri-stethoscope-line\" data-v-122feb71></i></div></div><div class=\"process__diagram--title\" data-v-122feb71><h3 class=\"process__diagram--h3\" data-v-122feb71>Atención<br class=\"br-escritorio\" data-v-122feb71> de paciente</h3></div></a><a name=\"process-item-3\" class=\"process__diagram--item\" data-v-122feb71><div class=\"process__diagram--circle\" data-v-122feb71><div class=\"process__diagram--number\" data-v-122feb71>3</div><div class=\"process__diagram--icon\" data-v-122feb71><i class=\"process__diagram--i ri-file-edit-line\" data-v-122feb71></i></div></div><div class=\"process__diagram--title\" data-v-122feb71><h3 class=\"process__diagram--h3\" data-v-122feb71>Firma y emisión<br class=\"br-escritorio\" data-v-122feb71> de informes</h3></div></a><a name=\"process-item-4\" class=\"process__diagram--item\" data-v-122feb71><div class=\"process__diagram--circle\" data-v-122feb71><div class=\"process__diagram--number\" data-v-122feb71>4</div><div class=\"process__diagram--icon\" data-v-122feb71><i class=\"process__diagram--i ri-hospital-line\" data-v-122feb71></i></div></div><div class=\"process__diagram--title\" data-v-122feb71><h3 class=\"process__diagram--h3\" data-v-122feb71>Operaciones</h3></div></a><a name=\"process-item-5\" class=\"process__diagram--item\" data-v-122feb71><div class=\"process__diagram--circle\" data-v-122feb71><div class=\"process__diagram--number\" data-v-122feb71>5</div><div class=\"process__diagram--icon\" data-v-122feb71><i class=\"process__diagram--i ri-line-chart-line\" data-v-122feb71></i></div></div><div class=\"process__diagram--title\" data-v-122feb71><h3 class=\"process__diagram--h3\" data-v-122feb71>Finanzas</h3></div></a></div><div class=\"process__diagram--line\" data-v-122feb71><div class=\"process__diagram--arrow\" data-v-122feb71></div><div class=\"process__diagram--arrow\" data-v-122feb71></div><div class=\"process__diagram--arrow\" data-v-122feb71></div><div class=\"process__diagram--arrow\" data-v-122feb71></div></div><ul class=\"process__diagram--bullets\" data-v-122feb71><li class=\"process__diagram--bullets-li\" data-v-122feb71><a href=\"#process-item-1\" class=\"process__diagram--bullet\" data-v-122feb71></a></li><li class=\"process__diagram--bullets-li\" data-v-122feb71><a href=\"#process-item-2\" class=\"process__diagram--bullet\" data-v-122feb71></a></li><li class=\"process__diagram--bullets-li\" data-v-122feb71><a href=\"#process-item-3\" class=\"process__diagram--bullet\" data-v-122feb71></a></li><li class=\"process__diagram--bullets-li\" data-v-122feb71><a href=\"#process-item-4\" class=\"process__diagram--bullet\" data-v-122feb71></a></li><li class=\"process__diagram--bullets-li\" data-v-122feb71><a href=\"#process-item-5\" class=\"process__diagram--bullet\" data-v-122feb71></a></li></ul></div>", 2)
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ri-close-line" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "process-modal__header" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "process-modal__title" }, "Proceso Completo de Exámenes Preocupacionales"),
  /*#__PURE__*/_createElementVNode("p", { class: "process-modal__subtitle" }, "Acompañamiento integral desde la solicitud hasta la gestión financiera")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "process-modal__steps" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "process-modal__step process-modal__step--yellow" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "process-modal__step-header" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "process-modal__step-icon" }, [
        /*#__PURE__*/_createElementVNode("i", { class: "ri-calendar-schedule-line" })
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "process-modal__step-info" }, [
        /*#__PURE__*/_createElementVNode("span", { class: "process-modal__step-badge" }, "Fase 1"),
        /*#__PURE__*/_createElementVNode("h3", { class: "process-modal__step-title" }, "Solicitud de atención"),
        /*#__PURE__*/_createElementVNode("p", { class: "process-modal__step-description" }, "Ingreso y organización de solicitudes de exámenes preocupacionales o ocupacionales enviadas por las empresas.")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "process-modal__step-features" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "process-modal__feature" }, [
        /*#__PURE__*/_createElementVNode("i", { class: "ri-check-line" }),
        /*#__PURE__*/_createElementVNode("span", null, "Registro de trabajadores y exámenes solicitados.")
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "process-modal__feature" }, [
        /*#__PURE__*/_createElementVNode("i", { class: "ri-check-line" }),
        /*#__PURE__*/_createElementVNode("span", null, "Validación de disponibilidad por sucursal o recursos.")
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "process-modal__feature" }, [
        /*#__PURE__*/_createElementVNode("i", { class: "ri-check-line" }),
        /*#__PURE__*/_createElementVNode("span", null, "Control de estados: ingresada, programada, pendiente.")
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "process-modal__feature" }, [
        /*#__PURE__*/_createElementVNode("i", { class: "ri-check-line" }),
        /*#__PURE__*/_createElementVNode("span", null, "Minimiza errores y agiliza la programación.")
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "process-modal__connector" }),
  /*#__PURE__*/_createElementVNode("div", { class: "process-modal__step process-modal__step--orange" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "process-modal__step-header" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "process-modal__step-icon" }, [
        /*#__PURE__*/_createElementVNode("i", { class: "ri-stethoscope-line" })
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "process-modal__step-info" }, [
        /*#__PURE__*/_createElementVNode("span", { class: "process-modal__step-badge" }, "Fase 2"),
        /*#__PURE__*/_createElementVNode("h3", { class: "process-modal__step-title" }, "Atención de paciente"),
        /*#__PURE__*/_createElementVNode("p", { class: "process-modal__step-description" }, "Gestión completa del flujo del paciente dentro del centro médico, desde sala de espera hasta la realización de exámenes.")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "process-modal__step-features" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "process-modal__feature" }, [
        /*#__PURE__*/_createElementVNode("i", { class: "ri-check-line" }),
        /*#__PURE__*/_createElementVNode("span", null, "Llamado a box mediante turnomático.")
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "process-modal__feature" }, [
        /*#__PURE__*/_createElementVNode("i", { class: "ri-check-line" }),
        /*#__PURE__*/_createElementVNode("span", null, "Registro de resultados clínicos, muestras y procedimientos.")
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "process-modal__feature" }, [
        /*#__PURE__*/_createElementVNode("i", { class: "ri-check-line" }),
        /*#__PURE__*/_createElementVNode("span", null, "Control de exámenes realizados y pendientes.")
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "process-modal__feature" }, [
        /*#__PURE__*/_createElementVNode("i", { class: "ri-check-line" }),
        /*#__PURE__*/_createElementVNode("span", null, "Gestión tanto para pacientes de empresas como particulares.")
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "process-modal__connector" }),
  /*#__PURE__*/_createElementVNode("div", { class: "process-modal__step process-modal__step--coral" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "process-modal__step-header" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "process-modal__step-icon" }, [
        /*#__PURE__*/_createElementVNode("i", { class: "ri-file-edit-line" })
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "process-modal__step-info" }, [
        /*#__PURE__*/_createElementVNode("span", { class: "process-modal__step-badge" }, "Fase 3"),
        /*#__PURE__*/_createElementVNode("h3", { class: "process-modal__step-title" }, "Firma y emisión de informes"),
        /*#__PURE__*/_createElementVNode("p", { class: "process-modal__step-description" }, "Generación, revisión y firma digital de informes médicos y psicológicos con validez legal.")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "process-modal__step-features" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "process-modal__feature" }, [
        /*#__PURE__*/_createElementVNode("i", { class: "ri-check-line" }),
        /*#__PURE__*/_createElementVNode("span", null, "Firma digital segura por profesional responsable.")
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "process-modal__feature" }, [
        /*#__PURE__*/_createElementVNode("i", { class: "ri-check-line" }),
        /*#__PURE__*/_createElementVNode("span", null, "Validación mediante código QR.")
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "process-modal__feature" }, [
        /*#__PURE__*/_createElementVNode("i", { class: "ri-check-line" }),
        /*#__PURE__*/_createElementVNode("span", null, "Asignación de vigencias según criterio clínico.")
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "process-modal__feature" }, [
        /*#__PURE__*/_createElementVNode("i", { class: "ri-check-line" }),
        /*#__PURE__*/_createElementVNode("span", null, "Emisión automatizada y trazabilidad del documento.")
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "process-modal__connector" }),
  /*#__PURE__*/_createElementVNode("div", { class: "process-modal__step process-modal__step--pink" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "process-modal__step-header" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "process-modal__step-icon" }, [
        /*#__PURE__*/_createElementVNode("i", { class: "ri-hospital-line" })
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "process-modal__step-info" }, [
        /*#__PURE__*/_createElementVNode("span", { class: "process-modal__step-badge" }, "Fase 4"),
        /*#__PURE__*/_createElementVNode("h3", { class: "process-modal__step-title" }, "Operaciones"),
        /*#__PURE__*/_createElementVNode("p", { class: "process-modal__step-description" }, "Centralización del historial, seguimiento y control operativo de todas las atenciones.")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "process-modal__step-features" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "process-modal__feature" }, [
        /*#__PURE__*/_createElementVNode("i", { class: "ri-check-line" }),
        /*#__PURE__*/_createElementVNode("span", null, "Gestión de solicitudes y estados operativos.")
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "process-modal__feature" }, [
        /*#__PURE__*/_createElementVNode("i", { class: "ri-check-line" }),
        /*#__PURE__*/_createElementVNode("span", null, "Acceso a historial completo de baterías y exámenes.")
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "process-modal__feature" }, [
        /*#__PURE__*/_createElementVNode("i", { class: "ri-check-line" }),
        /*#__PURE__*/_createElementVNode("span", null, "Organización de pendientes por empresa o particular.")
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "process-modal__feature" }, [
        /*#__PURE__*/_createElementVNode("i", { class: "ri-check-line" }),
        /*#__PURE__*/_createElementVNode("span", null, "Registro unificado para toma de decisiones y auditorías.")
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "process-modal__connector" }),
  /*#__PURE__*/_createElementVNode("div", { class: "process-modal__step process-modal__step--green" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "process-modal__step-header" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "process-modal__step-icon" }, [
        /*#__PURE__*/_createElementVNode("i", { class: "ri-line-chart-line" })
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "process-modal__step-info" }, [
        /*#__PURE__*/_createElementVNode("span", { class: "process-modal__step-badge" }, "Fase 5"),
        /*#__PURE__*/_createElementVNode("h3", { class: "process-modal__step-title" }, "Finanzas"),
        /*#__PURE__*/_createElementVNode("p", { class: "process-modal__step-description" }, "Administración de prefacturas, facturación y conciliación de pagos derivados de las atenciones realizadas.")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "process-modal__step-features" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "process-modal__feature" }, [
        /*#__PURE__*/_createElementVNode("i", { class: "ri-check-line" }),
        /*#__PURE__*/_createElementVNode("span", null, "Generación de prefacturas por empresa o servicio.")
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "process-modal__feature" }, [
        /*#__PURE__*/_createElementVNode("i", { class: "ri-check-line" }),
        /*#__PURE__*/_createElementVNode("span", null, "Emisión de facturas electrónicas (DTE).")
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "process-modal__feature" }, [
        /*#__PURE__*/_createElementVNode("i", { class: "ri-check-line" }),
        /*#__PURE__*/_createElementVNode("span", null, "Gestión de cuentas por cobrar y pagos conciliados.")
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "process-modal__feature" }, [
        /*#__PURE__*/_createElementVNode("i", { class: "ri-check-line" }),
        /*#__PURE__*/_createElementVNode("span", null, "Histórico de ventas y reportes financieros.")
      ])
    ])
  ])
], -1))

import { onMounted, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProcessSection',
  setup(__props) {

const isModalOpen = ref(false);

const openModal = () => {
  isModalOpen.value = true;
  document.body.style.overflow = 'hidden';
};

const closeModal = () => {
  isModalOpen.value = false;
  document.body.style.overflow = '';
};

onMounted(async () => {
  initializeProcessDiagram()
})


const initializeProcessDiagram = (): void => {
  document.addEventListener('DOMContentLoaded', () => {
    const content = document.querySelector<HTMLElement>('.process__diagram--content');
    const bullets = document.querySelectorAll<HTMLElement>('.process__diagram--bullet');
    const items = document.querySelectorAll<HTMLElement>('.process__diagram--item');
    let autoScrollInterval: number | undefined;

    if (content) {
      const updateActiveBullet = (): void => {
        const scrollLeft = content.scrollLeft;
        const scrollWidth = content.scrollWidth - content.clientWidth;
        const index = Math.round((scrollLeft / scrollWidth) * (bullets.length - 1));
        bullets.forEach((bullet, i) => {
          bullet.classList.toggle('active', i === index);
        });
      };

      const scrollToItem = (index: number): void => {
        const targetItem = items[index];
        if (targetItem) {
          const itemOffset = targetItem.offsetLeft - content.offsetLeft;
          content.scrollTo({ left: itemOffset, behavior: 'smooth' });
        }
      };

      const startAutoScroll = (): void => {
        autoScrollInterval = window.setInterval(() => {
          const scrollLeft = content.scrollLeft;
          const scrollWidth = content.scrollWidth - content.clientWidth;
          const currentIndex = Math.round((scrollLeft / scrollWidth) * (bullets.length - 1));
          const nextIndex = (currentIndex + 1) % items.length;
          scrollToItem(nextIndex);
        }, 3000);
      };

      const stopAutoScroll = (): void => {
        if (autoScrollInterval !== undefined) {
          clearInterval(autoScrollInterval);
        }
      };

      bullets.forEach((bullet, index) => {
        bullet.addEventListener('click', (e: Event) => {
          e.preventDefault();
          stopAutoScroll();
          scrollToItem(index);
          startAutoScroll();
        });
      });

      items.forEach((item) => {
        item.addEventListener('mouseenter', stopAutoScroll);
        item.addEventListener('mouseleave', startAutoScroll);
      });

      content.addEventListener('scroll', updateActiveBullet);
      updateActiveBullet(); // Inicializa la clase active en el bullet correcto

      startAutoScroll(); // Inicia el scroll automático
    }
  });
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", { class: "process__container container" }, [
      _hoisted_2,
      _createElementVNode("div", { class: "process__download" }, [
        _createElementVNode("button", {
          onClick: openModal,
          class: "process__download--a"
        }, " Ver proceso completo ")
      ])
    ]),
    _createVNode(_Transition, { name: "modal" }, {
      default: _withCtx(() => [
        (isModalOpen.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "process-modal",
              onClick: _withModifiers(closeModal, ["self"])
            }, [
              _createElementVNode("div", { class: "process-modal__content" }, [
                _createElementVNode("button", {
                  class: "process-modal__close",
                  onClick: closeModal
                }, _hoisted_5),
                _hoisted_6,
                _hoisted_7
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})